import React, { Component } from "react";

class ModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleProceed = () => {
    this.setState({ showModal: false });
    window.location.href = "/register-shipper";
  };

  render() {
    const { showModal } = this.state;

    return (
      <div>
        <button onClick={this.handleOpenModal}>Open Modal</button>

        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <p>Anda perlu melakukan registrasi sebagai shipper!</p>
              <button onClick={this.handleProceed}>Proceed</button>
              <button onClick={this.handleCloseModal}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ModalComponent;
